import { Alert, AlertTitle, Container, Step, StepContent, StepLabel, Stepper } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';

import { routerUrls } from '@/configs/routes/routerUrls';
import { useUserStore } from '@/configs/store';
import { IS_V2_WRITE_ENABLED } from '@/configs/v2Write';
import { MuiColors } from '@/types/colors';
import { withProvider } from '@/utils/withProvider';

import { LoginPageStoreProvider, useLoginPageStore } from './model';
import { CustomStepConnector } from './ui/StepConnector';
import { CustomStepIcon } from './ui/StepIcon';
import { useLoginSteps } from './ui/useLoginSteps';

import s from './LegacyLoginPage.module.scss';

/**
 * Основной вход — токеном Яндекс Трекера: без него не работает старый учёт (логи в Трекере),
 * новый работает с любым входом. Уже вошедших через KTSID не выкидываем — здесь они добавляют себе Яндекс
 */
const LegacyLoginPage = observer(() => {
  const { activeStep, error } = useLoginPageStore();
  const { isAuthorized } = useUserStore();
  const steps = useLoginSteps();

  return (
    <Container className={s.login} maxWidth="md" sx={{ mt: 4 }}>
      <div className={s.login__wrapper}>
        <h1>Вход в TimeLog</h1>

        <Alert severity="warning" sx={{ borderRadius: '6px' }}>
          <AlertTitle>Вход токеном Яндекс Трекера</AlertTitle>С ним работают и старый учёт (логи в
          Яндекс.Трекере), и новый. Нужен доступ к Трекеру с правами на чтение задач и создание
          worklog записей.
          {IS_V2_WRITE_ENABLED && ' Если нужен только новый учёт, можно войти через KTSID.'}
        </Alert>
        <Stepper
          activeStep={activeStep}
          orientation="vertical"
          connector={CustomStepConnector}
          sx={{
            '& .MuiStepContent-root': {
              marginLeft: '16px',
              borderColor: MuiColors.secondaryColor,
            },
          }}
        >
          {steps.map((step) => (
            <Step key={step.title} className={s.step}>
              <StepLabel slots={{ stepIcon: CustomStepIcon }}>
                <h2 className={s.step__title}>{step.title}</h2>
              </StepLabel>
              <StepContent>
                <div className={s.step__body}>{step.content}</div>
              </StepContent>
            </Step>
          ))}
        </Stepper>

        {error && (
          <Alert variant="filled" severity="error" sx={{ borderRadius: '6px' }}>
            {error}
          </Alert>
        )}

        {isAuthorized && (
          <Link to={routerUrls.v2.table} className={s['login__legacy-link']}>
            Перейти в новый учёт →
          </Link>
        )}
        {/* Пока новая система только бэкап, входят токеном; KTSID вернётся вместе с записью */}
        {!isAuthorized && IS_V2_WRITE_ENABLED && (
          <Link to={routerUrls.loginKtsid} className={s['login__legacy-link']}>
            Войти через KTSID — только новый учёт →
          </Link>
        )}
      </div>
    </Container>
  );
});

export default withProvider(LegacyLoginPage, LoginPageStoreProvider);
